import { Controller } from "@hotwired/stimulus"
import { disconnectObserver } from "../shared/infinite_scroll"

export default class extends Controller {
  static targets = ["menu", "loading"]
  static values = { url: String }

  connect() {
    this.loaded = false
    this.loading = false
    this.observer = null
  }

  disconnect() {
    this.disconnectObserver()
  }

  load() {
    if (this.loaded || this.loading) return
    this.fetchPage(1)
  }

  readAll(event) {
    fetch(event.currentTarget.dataset.url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(response => {
      if (response.ok) {
        this.menuTarget.querySelectorAll(".notification-unread").forEach(item => {
          item.classList.remove("notification-unread")
        })
        const badge = this.element.querySelector(".notification-badge")
        if (badge) badge.remove()
        event.currentTarget.closest("li").remove()
      }
    })
  }

  fetchPage(page) {
    this.loading = true

    fetch(`${this.urlValue}?page=${page}`, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => response.text())
      .then(html => {
        if (page === 1 && this.hasLoadingTarget) this.loadingTarget.remove()

        const temp = document.createElement("div")
        temp.innerHTML = html

        let appended = 0
        temp.querySelectorAll(".notification-item").forEach(item => {
          this.menuTarget.appendChild(item)
          appended++
        })

        if (appended === 0 && page === 1) {
          const empty = document.createElement("li")
          empty.className = "text-center text-muted py-3 px-3"
          empty.textContent = "No notifications"
          this.menuTarget.appendChild(empty)
        }

        const match = html.match(/<!-- next_page:(\d+) -->/)
        if (match) {
          const spinner = document.createElement("li")
          spinner.className = "text-center py-2 notification-sentinel-spinner"
          spinner.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>'

          const sentinel = document.createElement("li")
          sentinel.className = "notification-sentinel"
          sentinel.dataset.nextPage = match[1]

          this.menuTarget.appendChild(spinner)
          this.menuTarget.appendChild(sentinel)

          this.observeSentinel(sentinel, spinner)
        }

        if (page === 1) this.loaded = true
        this.loading = false
      })
  }

  observeSentinel(sentinel, spinner) {
    this.disconnectObserver()

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.loading) {
            const nextPage = parseInt(sentinel.dataset.nextPage)
            spinner.remove()
            sentinel.remove()
            this.disconnectObserver()
            this.fetchPage(nextPage)
          }
        })
      },
      { root: this.menuTarget, rootMargin: "50px" }
    )

    this.observer.observe(sentinel)
  }

  disconnectObserver() {
    disconnectObserver(this)
  }
}
